export default __webpack_public_path__ + "static/media/customer2.af3d3449.svg";